import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(", ");
  return d || e?.message || "Something went wrong";
};

export const fileUrl = (u) => (u && u.startsWith("/api/") ? BACKEND + u : u);

export async function downloadBlob(path, filename, method = "get") {
  const res = await api.request({ url: path, method, responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}

export const youtubeId = (url) => {
  const m = (url || "").match(/(?:youtu\.be\/|v=|embed\/|shorts\/)([\w-]{11})/);
  return m ? m[1] : null;
};

export const orderKey = {
  get: (id) => JSON.parse(localStorage.getItem("ce_order_keys") || "{}")[id] || "",
  set: (id, key) => {
    const all = JSON.parse(localStorage.getItem("ce_order_keys") || "{}");
    all[id] = key;
    localStorage.setItem("ce_order_keys", JSON.stringify(all));
  },
};
